import type { App } from 'vue';
import { closeToast, showFailToast, showLoadingToast, showSuccessToast, showToast } from 'vant';
import useClipboard from 'vue-clipboard3';
import { useGameStore, useHot, useTenantStore } from '@star/stores';
import { setSession } from '@star/utils';
import { playIsXY } from '@star/stores/src/helperPlay';
import { router } from '@/routers';
import { ConfigUtils, ElotType } from '@star/config';
import { $t2en, i18n } from '@star/languages';
import { Loop } from '@star/loop';
import { isSpecialTenant } from './public_utils';
import { isString } from 'lodash-es';

const { toClipboard } = useClipboard();

export const mb_t = (srt: string, arg2?: any, arg3?: any) => {
  if (srt && isString(srt)) {
    return i18n.global.t(srt, arg2, arg3);
  }
  return srt;
};

export const mb_toast = (str: string, type = 0) => {
  if (type === 0) {
    showToast(str);
  } else if (type === 1) {
    showSuccessToast(str);
  } else {
    showFailToast(str);
  }
};

// 加载动画
export const mb_loading: any = (opt = {}) => {
  let opts: any = {
    message: 'Loading...',
    forbidClick: false,
    loadingType: 'circular',
    duration: 0,
    ...opt,
  };
  mb_loading.clear = closeToast;
  return showLoadingToast(opts);
};

// 统一弹窗翻译处理 0 没有图标的弹窗 1成功弹窗 2错误弹窗
export const mb_err = (str: string, type = 0) => {
  if (str === undefined) return;
  if (typeof str !== 'string' && typeof str === 'object') {
    str = String(str);
  }
  // 如果是17-6 修改翻译文字
  if (isSpecialTenant(17, 6)) {
    str = str.includes('亲，请先登录哦') ? '注册成功，请联系在线客服领取奖金' : str;
  }
  if (str.includes('可用资产小于')) {
    let newstr = '可用资产小于';
    let endstr = str.replace(newstr, '');
    return mb_toast(i18n.global.t(newstr) + endstr, type);
  }
  if (str.includes('同一个银行卡绑定人数过多')) {
    return mb_toast(i18n.global.t('同一个银行卡绑定人数过多'), type);
  }
  if (str.includes('同一个姓名绑定人数过多')) {
    return mb_toast(i18n.global.t('同一个姓名绑定人数过多'), type);
  }
  if (/温馨提示：充值金额不能大于\d+金币/.test(str)) {
    return mb_toast(i18n.global.t('温馨提示：充值金额不能大于{n}金币', { n: str.replace(/[^0-9]/gi, '') }), type);
  }
  if (/当前(.+)账号已被绑定/.test(str)) {
    let s = /当前(.+)账号已被绑定(!|！)?/;
    let _s = str.replace(s, '$1');
    return mb_toast(i18n.global.t('当前{k}账号已被绑定', { k: _s }), type);
  }
  if (i18n.global.te(str) || i18n.global.locale?.value === 'cn') {
    return mb_toast(i18n.global.t(str), type);
  } else {
    // 这里调用后端接口
    const tenantStore = useTenantStore();
    // 元替换成金币
    str = str.replace('元', '金币');
    tenantStore
      .translationText({
        text: [str],
        language: i18n.global.locale?.value === 'zh' ? 'zh-TW' : i18n.global.locale?.value,
      })
      .then(res => {
        let strs = res[0] || str;
        mb_toast(strs, type);
      })
      .catch(err => {
        showFailToast(err?.info || str);
      });
  }
};

//复制
export const mb_copy = async text => {
  try {
    await toClipboard(text);
    showToast(mb_t('复制成功'));
  } catch (e) {
    //复制失败
    showToast(mb_t('复制失败'));
  }
};

// 后台返回的主题名
export const tResLoc = () => useHot().tResLoc;
export const appTemplate = () => useHot().appTemplate;

// 外部跳转链接 统一到jumpurl页面使用iframe 打开 '/jumpurl?url=' + url 或者 url存session中 前者权重最高
export const jumpUrl = (url, saveUrl = true) => {
  // if (saveUrl) {
  setSession('jumpurl', url);
  router.push('/wallet/iframe');
  // } else {
  //   router.push('/jumpurl?url=' + url);
  // }
};

export const myloop = Loop.getInstance();

/**
 * 增加类型，防止报错
 */
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    mb_t: typeof mb_t;
    mb_handleError: typeof mb_handleError;
  }
}

// 指定功能是否开启
export const tr = rightId => {
  const { hotData } = useHot();
  const { tenantInfo } = hotData;
  const rightIdDict = tenantInfo.value.rightIdDict || {};
  return !rightIdDict[rightId];
};

export const lotteryImg = item => {
  const gameStore = useGameStore();
  if (item.isOriginal) {
    return '';
  }
  let id = item.play_id || item.playid || item.playId || item.id;
  let sId = item.subplayid || item.spaly_id || item.sub_play_id;
  let play = ConfigUtils.getPlayInfo(id);
  const isXY = play ? playIsXY(play, sId) : false;
  let obj =
    gameStore.allLotteryData[
      id + ((isXY || item.play_cat === 4) && ElotType['SAMEID'].plays.indexOf(Number(id)) !== -1 ? '_' : '')
    ];
  return obj ? obj.img_url : '';
};

// 处理彩票图片
export const exlotteryimg = element => {
  const { imgDomain } = useTenantStore();

  const id = (element.play_id + '').substr(0, 3);
  let imgurl = '';
  let lang = $t2en(i18n.global.locale.value);
  if (element.base) {
    if (element.play_cat === 4) {
      imgurl =
        imgDomain +
        'staticQ/caipiao/default/' +
        lang +
        '/icon_play_' +
        (element.base ? element.base + '_XY' : element.base) +
        '.png';
    } else {
      imgurl = imgDomain + 'staticQ/caipiao/default/' + lang + '/icon_play_' + element.base + '.png';
    }
  } else {
    imgurl = imgDomain + 'staticQ/caipiao/default/' + lang + '/icon_play_' + element.play_id + '.png';
  }
  if (id === '504') {
    imgurl = `${imgDomain}staticQ/caipiao/504/${lang}/game_${element.play_id}.png`;
  } else if (id === '468') {
    imgurl = `${imgDomain}/staticQ/caipiao/468/game_${element.play_id}.png`;
  }
  return imgurl;
};

export default {
  install: (app: App) => {
    app.config.globalProperties['mb_t'] = mb_t;
    app.config.globalProperties['lotteryImg'] = lotteryImg;
    app.config.globalProperties['exlotteryimg'] = exlotteryimg;
    app.config.globalProperties['locale'] = i18n.global.locale;
    app.config.globalProperties['transferImg'] = val => {
      const map = {
        cn: val,
        en: val + '_en',
        vi: val + '_vi',
        th: val + '_th',
      };
      return map[i18n.global.locale] || map.en;
    };
    app.config.globalProperties['_darkTheme'] = 'black'; // 这个暂时用不上 已经在mainjs全局混淆了 THEME
    app.config.globalProperties['tResLoc'] = tResLoc().value;
    /**
     * 全局指令
     */
    // 防止重复点击
    app.directive('preventReClick', {
      // 当被绑定的元素挂载到 DOM 中时……
      mounted(el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true;
            setTimeout(() => {
              el.disabled = false;
            }, binding.value || 3000);
          }
        });
      },
    });
    app.directive('drag', {
      mounted(el) {
        const dragBox = el; //获取当前元素
        const action = (start, move, end) => {
          dragBox[start] = event => {
            let moveCounter = 0; //鼠标移动事件触发次数
            event.preventDefault(); //禁止页面滚动
            document[move] = e => {
              if (moveCounter > 4) {
                el.setAttribute('data-click', 0);
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let _el = null;
                if (start === 'onmousedown') {
                  _el = e;
                } else {
                  _el = e.changedTouches[0];
                }
                let left = _el.clientX - dragBox.offsetWidth / 2;
                let top = _el.clientY - dragBox.offsetHeight / 2;
                if (left < 0) {
                  left = 0;
                }
                if (top < 0) {
                  top = 0;
                }
                if (left > document.documentElement.clientWidth - dragBox.offsetWidth) {
                  left = document.documentElement.clientWidth - dragBox.offsetWidth;
                }
                if (top > document.documentElement.clientHeight - dragBox.offsetHeight) {
                  top = document.documentElement.clientHeight - dragBox.offsetHeight;
                }

                dragBox.style.left = left + 'px';
                dragBox.style.top = top + 'px';
              } else {
                moveCounter++;
              }
            };
            document[end] = e => {
              //鼠标弹起来的时候不再移动
              document[move] = null;
              //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
              document[end] = null;
              if (moveCounter <= 4) {
                el.setAttribute('data-click', 1);
                e.target.click();
              }
            };
          };
        };
        action('ontouchstart', 'ontouchmove', 'ontouchend');
        action('onmousedown', 'onmousemove', 'onmouseup');
      },
      updated(el) {
        const target = el.children[0];
        target.style.left = '';
        target.style.top = '';
      },
    });
  },
};
